import { IOpData, IReferenceType, IOpChangeState } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'


export class OpAlarmData implements IOpData {
    //Properties
    public idAlarmData: number
    public idAlarm: number
    public idDataType: number
    public indexNbr: number
    public value: any
    //Properties end

    //NavigationProperties
    public dataType: OpDataType
    //NavigationProperties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpData implementation
    public get idData() { return this.idAlarmData }
    //get idDataType() { return this.idDataType }
    public get indexNBR() { return this.indexNbr }
    //get value() { return this.value }
    //IOpData implementation end

    public static fromIOpData(data: IOpData): OpAlarmData {
        var newData: OpAlarmData = new OpAlarmData(null)
        newData.idAlarmData = data.idData,
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState
        return newData
    }

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idAlarmData = opObj.IdAlarmData
            this.idAlarm = opObj.IdAlarm
            this.idDataType = opObj.IdDataType
            this.indexNbr = opObj.IndexNbr
            this.value = opObj.Value

            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            IdAlarmData: this.idAlarmData,
            IdAlarm: this.idAlarm,
            IdDataType: this.idDataType,
            IndexNbr: this.indexNbr,
            Value: this.value
        }
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
}